import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';

const MyModal = ({ show, onHide, title, body, onConfirm, selectedItems, customerDetails, reportID, photoFile, latitude, longitude, demoAppInstalled }) => {
    const [isConfirmed, setIsConfirmed] = useState(false); // State to track if confirmed
    const history = useNavigate();

    const handleConfirm = () => {
        onConfirm(); // Execute the onConfirm function first
        setIsConfirmed(true); // Set confirmed to true
    };
    const handleClose = () => {
        setIsConfirmed(false); // Reset confirmation status
        onHide(); // Close the modal
        history.push(`/details/${reportID}`);
    };

    const modalStyle = {
        display: show ? "block" : "none",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
        overflow: "auto",
    };

    const modalContentStyle = {
        backgroundColor: "#fefefe",
        margin: "15% auto",
        padding: "20px",
        border: "1px solid #888",
        width: "50%",
        borderRadius: "10px",
    };

    const buttonStyle = {
        backgroundColor: "#007bff",
        border: "none",
        color: "white",
        padding: "10px 24px",
        textAlign: "center",
        textDecoration: "none",
        display: "inline-block",
        fontSize: "16px",
        margin: "4px 2px",
        cursor: "pointer",
        borderRadius: "8px",
    };


    return (
        <div style={modalStyle}>
            <div style={modalContentStyle}>
                <span style={{ float: "right", cursor: "pointer" }} onClick={handleClose}>
                    &times;
                </span>
                <h2>{title}</h2>
                {isConfirmed ? (
                    <>
                        <p style={{ color: "green", fontSize: "18px", marginBottom: "20px" }}>Submitted successfully!</p>
                        <Link to={`/details/${reportID}`}>
                            <button style={buttonStyle}>OK</button>
                        </Link>
                    </>
                ) : (
                    <>
                        <p>{body}</p>
                        {/* Display selected items */}
                        <div>
                            <h3>Selected Items:</h3>
                            <ul>
                                {selectedItems && selectedItems.map((item, index) => (
                                    <li key={index}>{item.Description}: {item.quantity}</li>
                                ))}
                            </ul>
                        </div>
                        {/* Display customer details */}
                        <div>
                            <h3>Customer Details:</h3>
                            <p>Company Name: {customerDetails.companyName}</p>
                            <p>Telephone: {customerDetails.tel}</p>
                            <p>Contact Person: {customerDetails.contactPerson}</p>
                            <p>Address: {customerDetails.address}</p>
                            <p>Ref No: {customerDetails.refNo}</p>
                            <p>Office Photo: {photoFile ? photoFile.name : "None attached"}</p>
                            <p>
                                Office Location:{" "}
                                {latitude != null && longitude != null
                                    ? `${latitude.toFixed(5)}, ${longitude.toFixed(5)}`
                                    : "Not captured"}
                            </p>
                            <p>
                                Demo App Installed:{" "}
                                {demoAppInstalled === true ? "Yes" : demoAppInstalled === false ? "No" : "Not specified"}
                            </p>
                        </div>
                        <button style={buttonStyle} onClick={handleConfirm}>
                            Confirm
                        </button>
                        <button style={buttonStyle} onClick={onHide}>
                            Cancel
                        </button>
                    </>
                )}
            </div>
        </div>
    );
};

export default MyModal;
